module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isApp) ? _c('div', {
    class: _vm.headerClass
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "z-index": "2000"
    }
  }, [_c('div', {
    staticClass: "header-left"
  }, [(_vm.menu) ? _c('app-menu', {
    staticClass: "header-left-menu"
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.isWechat) ? _c('p', {
    staticClass: "header-title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_vm._t("default"), _vm._v(" "), (_vm.cart) ? _c('div', {
    staticClass: "detail-icon detail-group"
  }, [_c('div', {
    staticClass: "carts-icon",
    on: {
      "click": _vm.goCarts
    }
  }, [_c('i'), _vm._v(" "), (_vm.cartNum > 0) ? _c('div', {
    staticClass: "fix-num"
  }, [_c('div', {
    staticClass: "cart-num"
  }, [_vm._v(_vm._s(_vm.cartNum))]), _vm._v(" "), _c('div', {
    staticClass: "triangle-right"
  })]) : _vm._e()])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a319d64"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/app-header/index.vue
// module id = 208
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 13 14 16 17 19 21 26 28 29 31 36 37 40 42